import { Icon, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Text, Pressable } from 'native-base';
import React from 'react';
import { StyleSheet, Animated } from 'react-native';

import { Container } from '../Container';

interface ButtonProps {
  animatedWidth: Animated.Value;
  isHovered: boolean;
  onHoverIn: () => void;
  onHoverOut: () => void;
  onToggleChatState: () => void;
}

export const Button: React.FC<ButtonProps> = ({
  animatedWidth,
  isHovered,
  onHoverIn,
  onHoverOut,
  onToggleChatState,
}) => {
  return (
    <Container borderRadius={BoxRadius.circular}>
      <Animated.View style={[styles.view, { minWidth: animatedWidth }]}>
        <Pressable
          onPress={onToggleChatState}
          onHoverOut={onHoverOut}
          onHoverIn={onHoverIn}
          p={Spacing['inline.nano']}>
          <HStack alignItems="center" justifyContent="space-between">
            {isHovered && (
              <Text
                variant="semibold"
                color={Color['neutral.white']}
                fontSize={Typography['fontsize.md']}>
                Precisa de ajuda?
              </Text>
            )}
            <Icon name="Chat" size="md" color={Color['neutral.white']} />
          </HStack>
        </Pressable>
      </Animated.View>
    </Container>
  );
};

const styles = StyleSheet.create({
  view: {
    backgroundColor: Color['brand.tertiary.principal'],
    borderRadius: 9999,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    overflow: 'hidden',
  },
});
